import React from 'react';
import { Redirect, Link } from 'react-router-dom';

const NotFoundPage = () => <Redirect to="/" />;

export default NotFoundPage;
